import {gql} from "@irati/utils/gql"

/* eslint graphql/template-strings: 0 */

const schema = gql`
  extend type Query {
    insWizard: InsWizard
    insDemo: InsightsDemoTenant
    insGlobal: InsGlobal
  }

  type InsWizard {
    cycle: Schedule
    isEditMode: Boolean
    nextURL: String
    prevURL: String
    questions: [Question]
    questionGroupId: String
  }

  input InsWizardParams {
    cycle: ScheduleInput
    isEditMode: Boolean
    nextURL: String
    prevURL: String
    questionGroupId: String
  }

  type InsGlobal {
    cycleId: String
    interestId: String
    tenant: String
  }
`

export default schema
